import { TestConnectionProps } from 'modules/clients/interfaces';

export const initialValues: TestConnectionProps = {
  email: '',
  password: '',
};
